import React, { useEffect, useState, useContext } from "react";
import shortid from "shortid";
import Modal from "@mui/material/Modal";

import { LOAD_POST_OFFER_COUNTER_OFFER_URL } from "../../../../../utils/api-ends";
import useHttp from "../../../../../hooks/useHttp";
import LoaderImg from "../../../../../assets/media/loader.gif";
import { ManageLoadPostDetailPageContext } from "../../";

const CounterModal = ({ userDetails }) => {
  const [counterOfferAmount, setCounterOfferAmount] = useState(null);
  const [isFixedPrice, setIsFixedPrice] = useState(null);
  const [counterOfferAmountErr, setCounterOfferAmountErr] = useState([]);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState([]);
  const { isLoading, error, sendRequests } = useHttp();

  const [loadPostDetailState, loadPostDetailContextDispatch] = useContext(
    ManageLoadPostDetailPageContext
  );
  const modalData = loadPostDetailState.counterModal.modalData;

  const onCounterAmountChange = (e) => setCounterOfferAmount(e.target.value);
  const onisFixedPriceChange = (e) => setIsFixedPrice(e.target.checked);

  const handleSubmit = () => {
    // Clear error messages
    setCounterOfferAmountErr([]);
    setSuccessMsg("");

    // Field is required
    if (["", null, undefined].includes(counterOfferAmount)) {
      setCounterOfferAmountErr(["This field is required."]);
      return;
    }

    const response = (data) => {
      setSuccessMsg(data.message);

      // Counter modal open from carrier page
      if (loadPostDetailState.counterModal?.openFrom === "carrier_page") {
        loadPostDetailContextDispatch({
          type: "CARRIER_COUNTER_OFFER",
          payload: {
            amount: counterOfferAmount,
            isFixedPrice: isFixedPrice,
          },
        });
      }
      // Shipper counter offer
      else if (loadPostDetailState.counterModal?.openFrom === "shipper_page") {
        loadPostDetailContextDispatch({
          type: "SHIPPER_COUNTER_OFFER",
          payload: {
            id: modalData.id,
            amount: counterOfferAmount,
            isFixedPrice: isFixedPrice,
          },
        });
      }

      // Close modal after few seconds
      setTimeout(() => {
        loadPostDetailContextDispatch({
          type: "CLOSE_COUNTER_MODAL",
        });
      }, 1000);
    };
    sendRequests(
      {
        url: LOAD_POST_OFFER_COUNTER_OFFER_URL(modalData?.id),
        method: "patch",
        data: {
          counter_amount: counterOfferAmount,
          is_amount_fixed: isFixedPrice,
        },
      },
      response
    );
  };

  // Show or hide error messages on mouse enter or leave
  const showErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "true");
  const hideErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "false");

  useEffect(() => {
    if (error) {
      setErrorMsg(error.message);
    }
  }, [error]);

  const closeModal = () =>
    loadPostDetailContextDispatch({
      type: "CLOSE_COUNTER_MODAL",
    });

  return (
    <Modal
      open={loadPostDetailState.counterModal?.status}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="mui-customized"
    >
      <div className="col-xl-4 col-lg-6 col-md-7 col-sm-10">
        <div className="counter-Offer-modal">
          {successMsg && <h6 className="text-center mb-3 ">{successMsg}</h6>}
          {errorMsg && <h6 className="text-center mb-3 ">{errorMsg}</h6>}
          <p className="note mb-4">
            ** Send your counter offer to <b>{userDetails?.full_name}</b>
            for <b>${modalData?.amount}</b>
          </p>

          <div className="input-box-area" single-labe="true">
            <label> Counter Offer Amount </label>
            <input
              type="number"
              placeholder="Counter Offer Amount"
              onChange={onCounterAmountChange}
              value={counterOfferAmount}
            />
            {counterOfferAmountErr?.map((err) => (
              <div
                key={shortid.generate()}
                className="error"
                show-tittle="false"
                onMouseEnter={showErrorMessage}
                onMouseLeave={hideErrorMessage}
              >
                <i className="fa-solid fa-circle-exclamation"></i>
                <p>{err}</p>
              </div>
            ))}
          </div>

          <div className="check-box">
            <input type="checkbox" onChange={onisFixedPriceChange} />
            <span>Fixed Price</span>
          </div>

          <div className="multiple-btn modal-button mt-5 justify-content-center">
            <button onClick={handleSubmit}>
              Submit Offer
              {isLoading && (
                <img style={{ width: "22px" }} src={LoaderImg} alt="Loader" />
              )}
            </button>
            <button onClick={closeModal}> Cancel </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(CounterModal);
